<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de contrato</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de contrato</option>
        <option v-for="TipoContrato in TiposContratoLocal" :key="TipoContrato.Id" :value="TipoContrato.TipoContratoId">{{TipoContrato.Nombre}}</option>        
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'  
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        TiposContratoLocal:[],
        idDelModelo:null
      }
    },
    props: {
      parametros:Object,
      idDelInput:String,
      valorDefinido:Number,
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }      
      this.$store.dispatch("A_SIAP_Catalogo_Establecer027TipoContrato", parametros);
    },
    created(){
      this.cargaCatalogoDeContrato();      
    },
    methods:{  
      cambiarDatos(evento) {        
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_SIAP_Catalogo_Establecer027TipoContrato", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      },   
      cargaCatalogoDeContrato(){
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba          
        }                                   
        
        axios.post(api.conexion + api.SIAP.catalogos.C027TipoContrato,peticion)
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.error(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {                           
              this.TiposContratoLocal = respuesta.data.TiposContrato;
            }
          })
          .catch(excepcion => 
          {
            console.error(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      }
    }    
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Comun/Catalogos/027TiposContrato.vue